import { createReducer } from '../../util';
import * as actions from '../actions/clients';
import { StatusState } from './common';

const initialStatusState : StatusState = {
    error: false,
    errorMessage: '',
    pending: false,
};

const initialState = {
    data: [],
    clientById: null,
    tinyList: [],
    parserList: [],
    timezones: [],
    products: null,
    productsForUserEdit: null,
    clientConfiguration: null,
    clientAccountConfiguration: null,
    clientFHIRConfiguration: null,
    clientClaimNotesConfiguration: null,
    branding: null,
    brandingDetails: null,
    hasCustomClaimStatusAccess: false,
    hasSummaryDashboardAccess: false,
    hasRcmTeamAccess:false,
    hasEAPGAccess:false,
    hasAIAccess:false,
    hasClaimChatBotAccess: false,
    hasClaimSemanticSearchAccess: false,
    hasPlanIdMappingAccess: false,
    supplementaryKnowledgeBaseEnabled: false,
    supplementaryPromptEnabled: false,
    isPercentageOfCharge: false,
    payerIntegrationConfigurations: [] as any[],
    list: {
        ...initialStatusState,
    },
    create: {
        ...initialStatusState,
    },
    update: {
        ...initialStatusState,
    },
    tiny: {
        ...initialStatusState,
    },
    bucketValidity: {}, // Keyvalue pair for the bucket validation
    ftpUserValidity: {}, // Keyvalue pair for the ftp user validation
    mergedClaims:{},
    deactivate: {
        ...initialStatusState,
    },
    get: {
        ...initialStatusState
    },
    activate: {
        ...initialStatusState,
    },
    getPlanIdMappingAccess: {
        ...initialStatusState,
    },
    getConfiguration: {
        ...initialStatusState,
    },
    getAccountConfiguration: {
        ...initialStatusState,
    },
    getFHIRConfiguration: {
        ...initialStatusState,
    },
    getClaimNotesConfiguration: {
        ...initialStatusState,
    },
    createConfiguration: {
        ...initialStatusState,
    },

    createAccountConfiguration: {
        ...initialStatusState,
    },
    createFHIRConfiguration: {
        ...initialStatusState,
    },
    createClaimNotesConfiguration: {
        ...initialStatusState,
    },
    testFHIRConnection:{
        ...initialStatusState,
    },
    testClaimNotesConnection:{
        ...initialStatusState,
    },

    addClaims: {
        ...initialStatusState,
    },
    updateConfiguration: {
        ...initialStatusState,
    },
    updateAccountConfiguration: {
        ...initialStatusState,
    },
    updateFHIRConfiguration: {
        ...initialStatusState,
    },
    updateClaimNotesConfiguration: {
        ...initialStatusState,
    },
    deleteConfiguration: {
        ...initialStatusState,
    },
    getTimeszones: {
        ...initialStatusState
    },
    getProducts: {
        ...initialStatusState
    },
    getProductsForUserEdit: {
        ...initialStatusState
    },
    getBranding: {
        ...initialStatusState,
    },
    getBrandingDetails: {
        ...initialStatusState,
    },
    createBranding: {
        ...initialStatusState,
    },
    updateBranding: {
        ...initialStatusState,
    },
    getCustomClaimStatus: {
        ...initialStatusState,
    },
    getSummaryDashboardAccess: {
        ...initialStatusState,
    },

    getRcmTeamAccess:{
        ...initialStatusState,
        
    },
    getEAPGAccess:{
        ...initialStatusState,
        
    },
    getAIAccess:{
        ...initialStatusState,
    },
    getPayerIntegrationConfigurations:{
        ...initialStatusState
    },
    AddUpdatePayerIntegrationConfigurations:{
        ...initialStatusState
    },
};

export default createReducer(initialState, {
    [actions.CLIENTS_LIST_PENDING]: (state) => ({
        ...state,
        list: {
            pending: true,
        },
    }),
    [actions.CLIENTS_LIST_FULFILLED]: (state, clients) => ({
        ...state,
        list: {
            ...initialStatusState,
        },
        data: clients,
    }),
    [actions.CLIENTS_LIST_REJECTED]: (state, errorMessage) => ({
        ...state,
        list: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CLIENTS_LIST_TINY_PENDING]: (state) => ({
        ...state,
        tiny: {
            pending: true,
        },
    }),
    [actions.CLIENTS_LIST_TINY_FULFILLED]: (state, clients) => ({
        ...state,
        tiny: {
            ...initialStatusState,
        },
        tinyList: [
            ...clients,
        ]
    }),
    [actions.CLIENTS_LIST_TINY_REJECTED]: (state, errorMessage) => ({
        ...state,
        tiny: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CLIENTS_GET_PENDING]: (state) => ({
        ...state,
        get: {
            pending: true,
        },
    }),
    [actions.CLIENTS_GET_FULFILLED]: (state, client) => ({
        ...state,
        get: {
            ...initialStatusState,
        },
        clientById: client,
    }),
    [actions.CLIENTS_GET_REJECTED]: (state, errorMessage) => ({
        ...state,
        get: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CLIENTS_CREATE_PENDING]: (state) => ({
        ...state,
        create: {
            pending: true,
        },
    }),
    [actions.CLIENTS_CREATE_FULFILLED]: (state) => ({
        ...state,
        create: {
            ...initialStatusState,
        }
    }),
    [actions.CLIENTS_CREATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        create: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CLIENTS_UPDATE_PENDING]: (state) => ({
        ...state,
        update: {
            pending: true,
        },
    }),
    [actions.CLIENTS_UPDATE_FULFILLED]: (state) => ({
        ...state,
        update: {
            ...initialStatusState,
        }
    }),
    [actions.CLIENTS_UPDATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        update: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.PARSERS_GET_FULFILLED]: (state, parsers) => ({
        ...state,
        parserList: [
            ...parsers,
        ]
    }),
    [actions.BUCKET_CHECK_PENDING]: (state, payload) => {
        return {
            ...state,
            bucketValidity: {
                ...state.bucketValidity,
                [`pending-${payload.index}`]: true,
            }
        };
    },
    [actions.BUCKET_CHECK_FULFILLED]: (state, { index, error }) => {
        return {
            ...state,
            bucketValidity: {
                ...state.bucketValidity,
                [`pending-${index}`]: false,
                [`done-${index}`]: error,
            }
        };
    },
    [actions.FTPUSER_CHECK_PENDING]: (state, payload) => {
        return {
            ...state,
            ftpUserValidity: {
                ...state.ftpUserValidity,
                [`pending-${payload.index}`]: true,
            }
        };
    },
    [actions.FTPUSER_CHECK_FULFILLED]: (state, { index, error }) => {
        return {
            ...state,
            ftpUserValidity: {
                ...state.ftpUserValidity,
                [`pending-${index}`]: false,
                [`done-${index}`]: error,
            }
        };
    },

    [actions.CLIENTS_DEACTIVATE_PENDING]: (state) => ({
        ...state,
        deactivate: {
            pending: true,
        },
    }),
    [actions.CLIENTS_DEACTIVATE_FULFILLED]: (state) => ({
        ...state,
        deactivate: {
            ...initialStatusState,
        }
    }),
    [actions.CLIENTS_DEACTIVATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        deactivate: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_ACTIVATE_PENDING]: (state) => ({
        ...state,
        activate: {
            pending: true,
        },
    }),
    [actions.CLIENTS_ACTIVATE_FULFILLED]: (state) => ({
        ...state,
        activate: {
            ...initialStatusState,
        }
    }),
    [actions.CLIENTS_ACTIVATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        activate: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_CONFIGURATION_CREATE_PENDING]: (state) => ({
        ...state,
        createConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_CONFIGURATION_CREATE_FULFILLED]: (state, clients) => ({
        ...state,
        createConfiguration: {
            ...initialStatusState,
        },
    }),
    [actions.CLIENTS_CONFIGURATION_CREATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        createConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_ACCOUNT_CONFIGURATION_CREATE_PENDING]: (state) => ({
        ...state,
        createAccountConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_ACCOUNT_CONFIGURATION_CREATE_FULFILLED]: (state, clients) => ({
        ...state,
        createAccountConfiguration: {
            ...initialStatusState,
        },
    }),
    [actions.CLIENTS_ACCOUNT_CONFIGURATION_CREATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        createAccountConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_FHIR_CONFIGURATION_CREATE_PENDING]: (state) => ({
        ...state,
        createFHIRConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_FHIR_CONFIGURATION_CREATE_FULFILLED]: (state, clients) => ({
        ...state,
        createFHIRConfiguration: {
            ...initialStatusState,
        },
    }),
    [actions.CLIENTS_FHIR_CONFIGURATION_CREATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        createFHIRConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_CLAIM_NOTES_CONFIGURATION_CREATE_PENDING]: (state) => ({
        ...state,
        createClaimNotesConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_CLAIM_NOTES_CONFIGURATION_CREATE_FULFILLED]: (state) => ({
        ...state,
        createClaimNotesConfiguration: {
            ...initialStatusState,
        },
    }),
    [actions.CLIENTS_CLAIM_NOTES_CONFIGURATION_CREATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        createClaimNotesConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_FHIR_CONNECTION_TEST_PENDING]: (state) => ({
        ...state,
        testFHIRConnection: {
            pending: true,
        },
    }),
    [actions.CLIENTS_FHIR_CONNECTION_TEST_FULFILLED]: (state) => ({
        ...state,
        testFHIRConnection: {
            ...initialStatusState,
        },
    }),
    [actions.CLIENTS_FHIR_CONNECTION_TEST_REJECTED]: (state, errorMessage) => ({
        ...state,
        testFHIRConnection: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_CLAIM_NOTES_CONNECTION_TEST_PENDING]: (state) => ({
        ...state,
        testClaimNotesConnection: {
            pending: true,
        },
    }),
    [actions.CLIENTS_CLAIM_NOTES_CONNECTION_TEST_FULFILLED]: (state) => ({
        ...state,
        testClaimNotesConnection: {
            ...initialStatusState,
        },
    }),
    [actions.CLIENTS_CLAIM_NOTES_CONNECTION_TEST_REJECTED]: (state, errorMessage) => ({
        ...state,
        testClaimNotesConnection: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),



    [actions.CLIENTS_ACCOUNT_ADD_CLAIMS_PENDING]: (state) => ({
        ...state,
        addClaims: {
            pending: true,
        },
    }),
    [actions.CLIENTS_ACCOUNT_ADD_CLAIMS_FULFILLED]: (state, mergedClaims) => ({
        ...state,
        addClaims: {
            ...initialStatusState,
        },
        mergedClaims
        
    }),
    [actions.CLIENTS_ACCOUNT_ADD_CLAIMS_REJECTED]: (state, errorMessage) => ({
        ...state,
        addClaims: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),



    [actions.CLIENTS_CONFIGURATION_UPDATE_PENDING]: (state) => ({
        ...state,
        updateConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_CONFIGURATION_UPDATE_FULFILLED]: (state, clients) => ({
        ...state,
        updateConfiguration: {
            ...initialStatusState,
        },
    }),
    [actions.CLIENTS_CONFIGURATION_UPDATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        updateConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_ACCOUNT_CONFIGURATION_UPDATE_PENDING]: (state) => ({
        ...state,
        updateAccountConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_ACCOUNT_CONFIGURATION_UPDATE_FULFILLED]: (state, clients) => ({
        ...state,
        updateAccountConfiguration: {
            ...initialStatusState,
        },
    }),
    [actions.CLIENTS_ACCOUNT_CONFIGURATION_UPDATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        updateAccountConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_FHIR_CONFIGURATION_UPDATE_PENDING]: (state) => ({
        ...state,
        updateFHIRConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_FHIR_CONFIGURATION_UPDATE_FULFILLED]: (state, clients) => ({
        ...state,
        updateFHIRConfiguration: {
            ...initialStatusState,
        },
    }),
    [actions.CLIENTS_FHIR_CONFIGURATION_UPDATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        updateFHIRConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_CLAIM_NOTES_CONFIGURATION_UPDATE_PENDING]: (state) => ({
        ...state,
        updateClaimNotesConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_CLAIM_NOTES_CONFIGURATION_UPDATE_FULFILLED]: (state) => ({
        ...state,
        updateClaimNotesConfiguration: {
            ...initialStatusState,
        },
    }),
    [actions.CLIENTS_CLAIM_NOTES_CONFIGURATION_UPDATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        updateClaimNotesConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),


    [actions.CLIENTS_CONFIGURATION_GET_PENDING]: (state) => ({
        ...state,
        getConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_CONFIGURATION_GET_FULFILLED]: (state, clientConfiguration) => ({
        ...state,
        getConfiguration: {
            ...initialStatusState,
        },
        clientConfiguration,
        hasPlanIdMappingAccess: clientConfiguration?.configuration?.usePlanIdMapping,
        hasRcmTeamAccess: clientConfiguration?.configuration?.customRCMTeamAssignmentEnabled,
        hasEAPGAccess: clientConfiguration?.configuration?.eapgEnabled,
        hasAIAccess: clientConfiguration?.configuration?.contractDocumentChatbotEnabled,
        hasClaimChatBotAccess: clientConfiguration?.configuration?.claimAnalysisChatbotEnabled,
        hasClaimSemanticSearchAccess: clientConfiguration?.configuration?.claimSemanticSearchEnabled,
        hasCustomClaimStatusAccess: clientConfiguration?.isSuperAdmin ? true : clientConfiguration?.configuration?.customClaimStatusEnabled,
        hasSummaryDashboardAccess: clientConfiguration?.isSuperAdmin ? true : clientConfiguration?.configuration?.summaryDashboardEnabled,
        supplementaryKnowledgeBaseEnabled: clientConfiguration?.configuration?.supplementaryKnowledgeBaseEnabled,
        supplementaryPromptEnabled: clientConfiguration?.configuration?.supplementaryPromptEnabled,
        isPercentageOfCharge: clientConfiguration?.configuration?.isPercentageOfCharge,

    }),
    [actions.CLIENTS_CONFIGURATION_GET_REJECTED]: (state, errorMessage) => ({
        ...state,
        getConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),


    [actions.CLIENTS_ACCOUNT_CONFIGURATION_GET_PENDING]: (state) => ({
        ...state,
        getAccountConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_ACCOUNT_CONFIGURATION_GET_FULFILLED]: (state, clientAccountConfiguration) => ({
        ...state,
        getAccountConfiguration: {
            ...initialStatusState,
        },
        clientAccountConfiguration
    }),
    [actions.CLIENTS_ACCOUNT_CONFIGURATION_GET_REJECTED]: (state, errorMessage) => ({
        ...state,
        getAccountConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),


    [actions.CLIENTS_CONFIGURATION_DELETE_PENDING]: (state) => ({
        ...state,
        deleteConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_CONFIGURATION_DELETE_FULFILLED]: (state, clients) => ({
        ...state,
        deleteConfiguration: {
            ...initialStatusState,
        },
    }),
    [actions.CLIENTS_CONFIGURATION_DELETE_REJECTED]: (state, errorMessage) => ({
        ...state,
        deleteConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_GET_TIMEZONES_PENDING]: (state) => ({
        ...state,
        getTimeszones: {
            pending: true,
        },
    }),
    [actions.CLIENTS_GET_TIMEZONES_FULFILLED]: (state, timezones) => ({
        ...state,
        getTimeszones: {
            ...initialStatusState,
        },
        timezones
    }),
    [actions.CLIENTS_GET_TIMEZONES_REJECTED]: (state, errorMessage) => ({
        ...state,
        getTimeszones: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_GET_PRODUCTS_PENDING]: (state) => ({
        ...state,
        getProducts: {
            pending: true,
        },
    }),
    [actions.CLIENTS_GET_PRODUCTS_FULFILLED]: (state, products) => ({
        ...state,
        getProducts: {
            ...initialStatusState,
        },
        products
    }),
    [actions.CLIENTS_GET_PRODUCTS_REJECTED]: (state, errorMessage) => ({
        ...state,
        getProducts: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_GET_PRODUCTS_USER_EDIT_PENDING]: (state) => ({
        ...state,
        getProductsForUserEdit: {
            pending: true,
        },
    }),
    [actions.CLIENTS_GET_PRODUCTS_USER_EDIT_FULFILLED]: (state, productsForUserEdit) => ({
        ...state,
        getProductsForUserEdit: {
            ...initialStatusState,
        },
        productsForUserEdit
    }),
    [actions.CLIENTS_GET_PRODUCTS_USER_EDIT_REJECTED]: (state, errorMessage) => ({
        ...state,
        getProductsForUserEdit: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.CLIENTS_GET_PRODUCTS_USER_EDIT_RESET]: (state) => ({
        ...state,
        productsForUserEdit: null
    }),

    [actions.CLIENTS_CONFIGURATION_RESET]: (state) => ({
        ...state,
        clientConfiguration: null
    }),

    [actions.CLIENTS_ACCOUNT_CONFIGURATION_RESET]: (state) => ({
        ...state,
        clientAccountConfiguration: null
    }),
    [actions.CLIENTS_FHIR_CONFIGURATION_RESET]: (state) => ({
        ...state,
        clientFHIRConfiguration: null
    }),
    [actions.CLIENTS_CLAIM_NOTES_CONFIGURATION_RESET]: (state) => ({
        ...state,
        clientClaimNotesConfiguration: null
    }),

    [actions.CLIENTS_ADDED_CLAIMS_RESET]: (state) => ({
        ...state,
        mergedClaims: {}
    }),

    [actions.RESET_BUCKETS]: (state) => {
        return {
            ...state,
            create: {
                ...initialStatusState,
            },
            update: {
                ...initialStatusState,
            },
            bucketValidity: {},
            ftpUserValidity: {}
        };
    },
    [actions.CLIENTS_RESET]: () => ({ ...initialState }),

    [actions.CLIENTS_BRANDING_GET_PENDING]: (state) => ({
        ...state,
        getBranding: {
            pending: true,
        },
    }),
    [actions.CLIENTS_BRANDING_GET_FULFILLED]: (state, branding) => ({
        ...state,
        getBranding: {
            ...initialStatusState,
        },
        branding: branding,
    }),
    [actions.CLIENTS_BRANDING_GET_REJECTED]: (state, errorMessage) => ({
        ...state,
        getBranding: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CLIENTS_BRANDING_CREATE_PENDING]: (state) => ({
        ...state,
        createBranding: {
            pending: true,
        },
    }),
    [actions.CLIENTS_BRANDING_CREATE_FULFILLED]: (state) => ({
        ...state,
        createBranding: {
            ...initialStatusState,
        }
    }),
    [actions.CLIENTS_BRANDING_CREATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        createBranding: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CLIENTS_BRANDING_UPDATE_PENDING]: (state) => ({
        ...state,
        updateBranding: {
            pending: true,
        },
    }),
    [actions.CLIENTS_BRANDING_UPDATE_FULFILLED]: (state) => ({
        ...state,
        updateBranding: {
            ...initialStatusState,
        }
    }),
    [actions.CLIENTS_BRANDING_UPDATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        updateBranding: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CLIENTS_BRANDING_DETAILS_GET_PENDING]: (state) => ({
        ...state,
        getBrandingDetails: {
            pending: true,
        },
    }),
    [actions.CLIENTS_BRANDING_DETAILS_GET_FULFILLED]: (state, brandingDetails) => ({
        ...state,
        getBrandingDetails: {
            ...initialStatusState,
        },
        brandingDetails: brandingDetails,
    }),
    [actions.CLIENTS_BRANDING_DETAILS_GET_REJECTED]: (state, errorMessage) => ({
        ...state,
        getBrandingDetails: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CLIENTS_CUSTOM_CLAIM_STATUS_PENDING]: (state) => ({
        ...state,
        getCustomClaimStatus: {
            pending: true,
        },
    }),
    [actions.CLIENTS_CUSTOM_CLAIM_STATUS_FULFILLED]: (state, hasCustomClaimStatusAccess) => ({
        ...state,
        getCustomClaimStatus: {
            ...initialStatusState,
        },
        hasCustomClaimStatusAccess
    }),
    [actions.CLIENTS_CUSTOM_CLAIM_STATUS_REJECTED]: (state, errorMessage) => ({
        ...state,
        getCustomClaimStatus: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CLIENTS_SUMMARY_DASHBOARD_ACCESS_PENDING]: (state) => ({
        ...state,
        getSummaryDashboardAccess: {
            pending: true,
        },
    }),
    [actions.CLIENTS_SUMMARY_DASHBOARD_ACCESS_FULFILLED]: (state, hasSummaryDashboardAccess) => ({
        ...state,
        getSummaryDashboardAccess: {
            ...initialStatusState,
        },
        hasSummaryDashboardAccess
    }),
    [actions.CLIENTS_SUMMARY_DASHBOARD_ACCESS_REJECTED]: (state, errorMessage) => ({
        ...state,
        getSummaryDashboardAccess: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CLIENTS_FHIR_CONFIGURATION_GET_PENDING]: (state) => ({
        ...state,
        getFHIRConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_FHIR_CONFIGURATION_GET_FULFILLED]: (state, clientFHIRConfiguration) => ({
        ...state,
        getFHIRConfiguration: {
            ...initialStatusState,
        },
        clientFHIRConfiguration,
    }),
    [actions.CLIENTS_FHIR_CONFIGURATION_GET_REJECTED]: (state, errorMessage) => ({
        ...state,
        getFHIRConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CLIENTS_CLAIM_NOTES_CONFIGURATION_GET_PENDING]: (state) => ({
        ...state,
        getClaimNotesConfiguration: {
            pending: true,
        },
    }),
    [actions.CLIENTS_CLAIM_NOTES_CONFIGURATION_GET_FULFILLED]: (state, clientClaimNotesConfiguration) => ({
        ...state,
        getClaimNotesConfiguration: {
            ...initialStatusState,
        },
        clientClaimNotesConfiguration,
    }),
    [actions.CLIENTS_CLAIM_NOTES_CONFIGURATION_GET_REJECTED]: (state, errorMessage) => ({
        ...state,
        getClaimNotesConfiguration: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
        [actions.CLIENTS_PAYER_INTEGRATIONS_CONFIGURATION_GET_PENDING]: (state) => ({
        ...state,
        getPayerIntegrationConfigurations: { 
            pending: true 
        },
    }),

    [actions.CLIENTS_PAYER_INTEGRATIONS_CONFIGURATION_GET_FULFILLED]: (
        state,
        payerIntegrationConfigurations,
    ) => ({
        ...state,
        getPayerIntegrationConfigurations: { 
            ...initialStatusState 
        },
        payerIntegrationConfigurations,
    }),

    [actions.CLIENTS_PAYER_INTEGRATIONS_CONFIGURATION_GET_REJECTED]: (
        state, 
        errorMessage
    ) => ({
        ...state,
        getPayerIntegrationConfigurations: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CLIENTS_PAYER_INTEGRATIONS_CONFIGURATION_CREATE_UPDATE_PENDING]: (state) => ({
        ...state,
        AddUpdatePayerIntegrationConfigurations: {
            pending: true,
        },
    }),
    [actions.CLIENTS_PAYER_INTEGRATIONS_CONFIGURATION_CREATE_UPDATE_FULFILLED]: (
        state,
        clients,
    ) => ({
        ...state,
        AddUpdatePayerIntegrationConfigurations: {
            ...initialStatusState,
        },
    }),
    [actions.CLIENTS_PAYER_INTEGRATIONS_CONFIGURATION_CREATE_UPDATE_REJECTED]: (
        state,
        errorMessage,
    ) => ({
        ...state,
        AddUpdatePayerIntegrationConfigurations: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
        [actions.CLIENTS_PAYER_INTEGRATIONS_CONFIGURATION_RESET]: (state) => ({
        ...state,
        payerIntegrationConfigurations: null
    }),


// plan Id Mapping

});